
const MEMCOUPON_LIST = 'MEMCOUPON_LIST';
const MEMCOUPON_PAGE = 'MEMCOUPON_PAGE';
const MEMCOUPON_CONDITION = 'MEMCOUPON_CONDITION';

const MemCouponListModel = function () {
  const name = 'memcouponList';
  return {
    name,
    state: {
      list: [],
      condition: {
        status:1,
      },
      page: {
        cur_page: 1,
        size: 30,
        total: 0
      }
    },
    selectors: (state) => {
      const currentState = state[name];
      const selectors = {
        getList: () => currentState.list,
        getPage: () => currentState.page,
        getCondition: () => currentState.condition,
      };
      return selectors;
    },
    actions: {
      changeList: (list) => (dispatch, getState) => {
        dispatch({
          type: MEMCOUPON_LIST,
          list
        });
      },
      changePage: (page) => (dispatch, getState) => {
        dispatch({
          type: MEMCOUPON_PAGE,
          page
        });
      },
      changeCondition: (key, value) => (dispatch, getState) => {
        dispatch({
          type: MEMCOUPON_CONDITION,
          key,
          value
        });
      },
    },
    reducers: {
      list: (state = MemCouponListModel.state.list, action) => {
        if (action.type === MEMCOUPON_LIST) {
          return [...action.list];
        }
        return state;
      },
      page: (state = MemCouponListModel.state.page, action) => {
        if (action.type === MEMCOUPON_PAGE) {
          return Object.assign({}, state, action.page);
        }
        return state;
      },
      condition: (state = MemCouponListModel.state.condition, action) => {
        if (action.type === MEMCOUPON_CONDITION) {
          const { key, value } = action;
          let obj = {};
          obj[key] = value;
          return Object.assign({}, state, obj);
        }
        return state;
      },
    }
  };
}();

export default MemCouponListModel;


// WEBPACK FOOTER //
// ./src/models/MemCouponListModel.js